export const BRAND_COLOR = '#3dcdc2';
export const ACCENT = '#33b0a6';
export const LIGHT_ACCENT = '#61d6cc';

// Text
export const TITLE_COLOR = '#080f12';
export const SUB_TITLE_COLOR = '#595e61';
export const BODY_COLOR = '#404547';
export const DISABLED_TEXT = '#aeb0b0';
export const DIVIDER = '#707070';
export const ERROR_TEXT = '#242424';
export const BLACK_TEXT = '#000000';

// Backgrounds
export const LAYOUT_BG_COLOR = '#ffffff';
export const NAV_BG_COLOR = '#24292e';
export const ERROR_BG_COLOR = '#ff695c21';

// ALERTS

// Error
export const ERROR = '#d5160e';
export const ERROR_ACCENT = '#f9dadc';
export const ERROR_BORDER = '#BA1A1A';

// Success
export const SUCCESS = '#52bd40';
export const SUCCESS_ACCENT = '#e8f4e8';

// Warning
export const WARNING = '#ffb607';
export const WARNING_ACCENT = '#fef2da';

// Info
export const INFO = '#00a8e1';
export const INFO_ACCENT = '#e6f6ff';

// Common
export const LIGHT_GRAY = '#757a7d';
export const BG_AVATAR = '#919496';
